// @ts-check

import axios from 'axios'
import { API_BASE_URL, STORAGE_URL } from './api.model'
import { createJsonRpc } from './api-rpc'

export const api = axios.create({
	baseURL: API_BASE_URL,
})

export const storageApi = axios.create({
	baseURL: STORAGE_URL,
})

export default {

	signUp:
		createJsonRpc(api, 'SignUp'),

	signIn:
		createJsonRpc(api, 'SignIn'),

	getCurrentSessionInfo:
		createJsonRpc(api, 'GetCurrentSessionInfo'),

	refreshAuthToken:
		createJsonRpc(api, 'RefreshAuthToken'),

	getUserInfo:
		createJsonRpc(api, 'GetUserInfo'),

	addUserCredentials:
		createJsonRpc(api, 'AddUserCredentials'),

	updateUserCredentials:
		createJsonRpc(api, 'UpdateUserCredentials'),

	getUserCredentials:
		createJsonRpc(api, 'GetUserCredentials'),

	getUserSessions:
		createJsonRpc(api, 'GetUserSessions'),

	terminateSession:
		createJsonRpc(api, 'TerminateSession'),

	updateUserInfo:
		createJsonRpc(api, 'UpdateUserInfo'),

	restoreUserAccount:
		createJsonRpc(api, 'RestoreUserAccount'),

	createUploadFileRequest:
		createJsonRpc(api, 'CreateUploadFileRequest'),

	createUploadRequest:
		createJsonRpc(api, 'createUploadRequest'),

	deleteUserAccount:
		createJsonRpc(api, 'DeleteUserAccount'),

	grantAuthorizationCode:
		createJsonRpc(api, 'OAuthAuthorizationCodeGrant'),

	authorize:
		createJsonRpc(api, 'OAuthAuthorize'),

	checkApplicationIsBoundToUser:
		createJsonRpc(api, 'IsApplicationBoundToUser'),

	confirmAction:
		createJsonRpc(api, 'ConfirmAction'),

	checkNeedsConfirmation:
		createJsonRpc(api, 'IsConfirmationNeeded'),

	sendConfirmationEmail:
		createJsonRpc(api, 'SendConfirmationEmail'),

	createApplication:
		createJsonRpc(api, 'CreateApplication'),

	getApplications:
		createJsonRpc(api, 'GetApplications'),

	updateApplication:
		createJsonRpc(api, 'UpdateApplication'),

	deleteApplication:
		createJsonRpc(api, 'DeleteApplication'),

	deleteUserCredentials:
		createJsonRpc(api, 'DeleteUserCredentials'),

	exchangeSSOToken:
		createJsonRpc(api, 'ExchangeSSOToken'),

	getOAuthBindingInfo:
		createJsonRpc(api, 'GetOAuthBindingInfo'),

	socialLogin:
		createJsonRpc(api, 'SocialLogin'),

	/**
	 *
	 * @param {{ file: Blob, fileUploadId: string, authToken: string }} params
	 * @returns {Promise<{ file: { _id: string } }>}
	 */
	async uploadFile(params) {
		/** @type {import('axios').AxiosRequestConfig<FormData>} */
		const options = {
			headers: {
				'Auth-Token': params.authToken,
				'Content-Type': 'multipart/form-data'
			},
			responseType: 'json',
		}
		const formData = new FormData()
		formData.append('file', params.file)

		return storageApi
			.post(`/file/${ params.fileUploadId }`, formData, options)
			.then(res => res.data)
	}
}

